import * as Types from 'constants/ActionTypes'
import { actionRequest } from './index'

export const fetchBodyWeightUnits = () => (...args) => {
    return actionRequest(...args)({
        type: Types.FETCH_BODY_WEIGHT_UNITS,
        url: `/body-weight-unit-measures`,
        method: 'get'   
    })
}